<template>
  <guest-layout>
    <template #header>
      <font-awesome-icon icon="fas fa-circle-info" />
      Masukkan email atau nomor HP Anda untuk menerima link reset password
    </template>

    <Head title="Forgot Password" />

    <div class="container p-6 mx-auto my-6 max-w-8xl">
      <div class="flex flex-wrap justify-between bg-white rounded-lg shadow-xl md:flex">
        <!-- Form Section -->
        <div class="w-full md:w-6/12 lg:w-5/12">
          <form class="px-10 py-4 overflow-hidden" @submit.prevent="submit">
            <h1 class="text-2xl font-bold text-center">Reset Password</h1>
            <div class="w-24 mx-auto mt-6 border-b-2" />

            <!-- Email -->
            <text-input
              id="email"
              v-model="form.email"
              :error="form.errors.email"
              class="mt-10"
              label="Email"
              type="email"
              autofocus
            />

            <!-- Phone (WhatsApp) -->
            <text-input
              id="phone"
              v-model="form.phone"
              :error="form.errors.phone"
              class="mt-6"
              label="Nomor HP (WhatsApp)"
              type="tel"
              placeholder="08xxxxxxxxxx"
            />

            <!-- Error Message -->
            <div v-if="form.hasErrors" class="mt-4 text-sm text-red-600">
              Terdapat kesalahan input. Silakan cek kembali.
            </div>

            <!-- Submit Button -->
            <loading-button
              :loading="form.processing"
              class="mt-6 btn-green"
              type="submit"
            >
              <font-awesome-icon icon="fas fa-paper-plane" />
              &nbsp;Kirim Link Reset
            </loading-button>

            <!-- Status -->
            <p v-if="status" class="mt-4 text-sm text-green-600">
              {{ status }}
            </p>
          </form>
        </div>

        <!-- Right Section -->
        <div class="relative hidden w-0 rounded-tr-lg rounded-br-lg md:w-6/12 lg:w-7/12 md:flex md:flex-col">
          <img src="/images/background.png" alt="Background" class="flex-1 object-cover" />
        </div>
      </div>
    </div>
  </guest-layout>
</template>

<script>
import { Head } from '@inertiajs/inertia-vue3'
import TextInput from '@/Shared/TextInput'
import LoadingButton from '@/Shared/LoadingButton'
import GuestLayout from '@/Layouts/GuestLayout.vue'

export default {
  components: {
    Head,
    TextInput,
    LoadingButton,
    GuestLayout,
  },
  props: {
    status: String,
  },
  data() {
    return {
      form: this.$inertia.form({
        email: '',
        phone: '',
      }),
    }
  },
  methods: {
    submit() {
      this.form.post('/forgot-password')
    },
  },
}
</script>
